import isObject from './isObject';

export default function isFunction(fn) {
  return isObject(fn)
    && Object.prototype.toString.call(fn) === '[object Function]';
}
